<template>
  <div class="wrapper fill-vh">
    <MainInfo />
    <EmailForm />
  </div>
</template>

<script>
// @ is an alias to /src
import MainInfo from "@/components/MainInfo";
import EmailForm from "@/components/EmailForm";

export default {
  name: "Home",
  components: {
    MainInfo,
    EmailForm,
  },
};
</script>
<style scoped>
@media (min-width: 1025px) {
  .wrapper {
    display: flex;
  }
}
</style>
